<app-analytics-risk [filters]="filters" [hideFilters]="hideFilters" [dashboardType]="dashboardType"></app-analytics-risk>
